import moment from 'moment';
import Location from '../basic-types/Location';
import BasicType from './BasicType';

export default class TimeAndLocation implements BasicType {
    public time: moment.Moment;
    public location: Location;

    constructor(time: moment.Moment, location: Location) {
        this.time = time;
        this.location = location;
    }

    public toString(): string {
        return `Time=(${this.time.format('DD.MM.YYYY HH:mm')}), Location=(${this.location.toString()})`;
    }

    equals(other: TimeAndLocation): boolean {
        return this.location.equals(other.location) && this.time.isSame(other.time);
    }

    public static fromJson(json: any): TimeAndLocation {
        return new TimeAndLocation(moment(json.time), Location.fromJson(json.location));
    }
}
